import { render, staticRenderFns } from "./TwButton.vue?vue&type=template&id=198fc0b1&"
import script from "./TwButton.vue?vue&type=script&lang=js&"
export * from "./TwButton.vue?vue&type=script&lang=js&"
import style0 from "./TwButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports